import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const phoneColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'phone1',
  headerName: 'Phone',
  initialHide: true,
};
